import { ResetPasswordContainer } from '@/containers/auth/reset-password-container';
import Footer from '@/components/organisms/Footer';
import { ChevronLeftIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { AUTH_PAGE_CONTENT_CLASS_NAME } from './auth-layout';

export const ResetPasswordPage = () => {
  const navigate = useNavigate();

  return (
    <div className="scrollbar flex flex-col overflow-y-auto bg-gr-50 max-md:bg-white">
      <div className={AUTH_PAGE_CONTENT_CLASS_NAME}>
        <div className="space-y-5 max-md:w-full">
          <button className="flex items-center gap-3 max-md:px-5" onClick={() => navigate(-1)}>
            <ChevronLeftIcon className="h-8 w-8 max-md:h-6 max-md:w-6" />
            <div className="text-gr-900 Title2S24 max-md:Body1S16">비밀번호 재설정</div>
          </button>
          <ResetPasswordContainer />
        </div>
      </div>
      <Footer />
    </div>
  );
};
